import useConnect from "./connect"
import WithLoader from "~/ui-rtk/components/layout/WithLoader/WithLoader"
import BrandMediaOptimizationDashboard from "~/ui-rtk/components/features/dashboards/BrandMediaOptimizationDashboard/BrandMediaOptimizationDashboard"
import useReconnectSourcesBanner from "~/ui-rtk/hooks/reconnect-sources-banner"
import { useEffect } from "react"
import ReconnectBanner from "~/ui-rtk/components/layout/ReconnectBanner/ReconnectBanner"

export default function PageBrandMediaOptimization() {
  const { content, isLoading, requiredSources } = useConnect()

  const { connectorsToReconnect, setRequiredSources } =
    useReconnectSourcesBanner()

  useEffect(() => {
    setRequiredSources(requiredSources)
  }, [requiredSources])

  return (
    <WithLoader isLoading={isLoading}>
      <ReconnectBanner connectors={connectorsToReconnect} />
      <BrandMediaOptimizationDashboard
        slug={content.slug}
        items={content.content.items}
        title={content.content.title}
        parent={content.parent}
        periodPicker={content.content.periodPicker}
      />
    </WithLoader>
  )
}
